// =====================================================================
// WeekdaysPicker — seletor de dias da semana via chips (Fase 3, S38).
//
// CONVENCAO do valor (DEFINIDA AQUI):
//   String CSV de dias em ingles minusculo:
//     "monday,tuesday,wednesday,thursday,friday"
//     "saturday,sunday"
//     "" (vazio = nenhum)
//
//   Mesma nomenclatura do schedule_json (consistencia).
//   Coluna no DB: VARCHAR(32) — cabe a semana toda (27 chars sem
//   sabado completo, 35 com — esta tudo na margem ja que o workflow
//   limita a 32 chars; aceita o weekdays comum mas nao todos os dias).
//
// Usado em:
//   - clinic_config.working_days
//   - clinic_benefits.available_days
// =====================================================================
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Chip, Box, Typography, Button } from "@material-ui/core";

const DAYS = [
  { key: "monday",    label: "Seg" },
  { key: "tuesday",   label: "Ter" },
  { key: "wednesday", label: "Qua" },
  { key: "thursday",  label: "Qui" },
  { key: "friday",    label: "Sex" },
  { key: "saturday",  label: "Sáb" },
  { key: "sunday",    label: "Dom" }
];

const useStyles = makeStyles((theme) => ({
  root: { display: "flex", flexWrap: "wrap", gap: theme.spacing(1), alignItems: "center" },
  chip: {
    fontWeight: 600,
    transition: "all 0.15s ease"
  },
  chipActive: {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    "&:hover": {
      background: theme.palette.primary.dark
    }
  },
  presetBtn: {
    fontSize: "0.75rem",
    textTransform: "none",
    padding: "2px 8px"
  },
  presets: { display: "flex", gap: 4, marginLeft: "auto" }
}));

// Parse CSV → array de keys, filtrando invalidos
const parseValue = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  return String(value)
    .split(",")
    .map((s) => s.trim().toLowerCase())
    .filter((s) => DAYS.some((d) => d.key === s));
};

// Serializa array → CSV na ordem canonica seg→dom
const serialize = (selected) => {
  const set = new Set(selected);
  return DAYS.filter((d) => set.has(d.key))
    .map((d) => d.key)
    .join(",");
};

const WeekdaysPicker = ({ value, onChange }) => {
  const classes = useStyles();
  const selected = parseValue(value);

  const toggle = (key) => {
    const set = new Set(selected);
    if (set.has(key)) set.delete(key);
    else set.add(key);
    onChange(serialize(Array.from(set)));
  };

  const applyPreset = (keys) => onChange(serialize(keys));

  return (
    <Box className={classes.root}>
      {DAYS.map((d) => {
        const active = selected.includes(d.key);
        return (
          <Chip
            key={d.key}
            label={d.label}
            size="small"
            onClick={() => toggle(d.key)}
            className={`${classes.chip} ${active ? classes.chipActive : ""}`}
            variant={active ? "default" : "outlined"}
            color={active ? "primary" : "default"}
          />
        );
      })}
      <Box className={classes.presets}>
        <Button
          size="small"
          className={classes.presetBtn}
          onClick={() => applyPreset(["monday","tuesday","wednesday","thursday","friday"])}
        >
          Seg–Sex
        </Button>
        <Button
          size="small"
          className={classes.presetBtn}
          onClick={() => applyPreset(["monday","tuesday","wednesday","thursday","friday","saturday"])}
        >
          + Sáb
        </Button>
        <Button
          size="small"
          className={classes.presetBtn}
          onClick={() => applyPreset([])}
        >
          Limpar
        </Button>
      </Box>
    </Box>
  );
};

export default WeekdaysPicker;
